import React from 'react';
import { STRATIFY_APP_RETURN, billingReturnTrace } from '../billing/appReturn';
export default function OpenStratifyButton() {
  return <div className="mt-6 space-y-2">
    <a href={STRATIFY_APP_RETURN} onClick={() => billingReturnTrace('open_stratify_clicked')}
      className="inline-flex rounded-xl bg-ink px-5 py-3 text-sm font-semibold text-white">Open Stratify</a>
    <p className="text-xs text-muted">If the app does not open, switch back to Stratify. Your plan will refresh there.</p>
  </div>;
}
